import React from "react";
import "../mycontent.css";
import { Form, Input, Button, Card } from "antd";
import { connect } from "react-redux";
import {
  fetchProject,
  createProject,
  updateProject,
  emptyProject,
} from "../../../../store/actions/selfProjectAction";
import { MY_CONTENT_BASE_URL } from "../../../../constants/LookupConst";
import CircularProgress from "../../../../components/CircularProgress";
import { toast } from "react-toastify";

import InputSelectAdd from "../../../../components/InputSelectAdd";

// const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

class SelfProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  formRef = React.createRef();

  async componentDidMount() {
    const {
      match: { params },
      fetchProject,
    } = this.props;
    if (params.id) {
      await fetchProject(params.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedProject } = this.props;
    if (
      prevProps.selectedProject &&
      prevProps.selectedProject._id !== selectedProject._id
    ) {
      this.setState({
        category: selectedProject.category,
        mainsubjectname: selectedProject.mainsubjectname,
        subsubjectname: selectedProject.subsubjectname,
      });
    }
  }

  async componentWillUnmount() {
    this.props.emptyProject();
  }

  onCategoryChange = (data) => {
    this.setState({ category: data });
  };
  onMainSubjectNameChange = (data) => {
    this.setState({ mainsubjectname: data });
  };
  onSubSubjectNameChange = (data) => {
    this.setState({ subsubjectname: data });
  };

  render() {
    const onFinish = async (values) => {
      const { history } = this.props;
      const { category, mainsubjectname, subsubjectname } = this.state;
      if (!params.id) {
        await this.props.createProject(
          { ...values, category, mainsubjectname, subsubjectname },
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      } else {
        await this.props.updateProject(
          { ...values, category, mainsubjectname, subsubjectname },
          params.id,
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      }
      history.push(`${MY_CONTENT_BASE_URL}?tab=project`);
    };

    const {
      // lookupProjectYears,
      // location: { search },
      match: { params },
      selectedProject,
      loading,
      // countries,
      // professors,
    } = this.props;
    const data = selectedProject;
    if (!(data && data._id) && params.id) {
      return (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      );
    }
    return (
      <Card className="gx-card blast-mc" title="Create Project">
        {!loading ? (
          <Form
            ref={this.formRef}
            {...formItemLayout}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
          >
            <Form.Item
              name="name"
              label="Name"
              initialValue={data.name}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid name",
                },
                {
                  required: true,
                  message: "Please input name",
                },
              ]}
            >
              <Input placeholder="Please enter a name" value={data.name} />
            </Form.Item>
            <InputSelectAdd
              category={"category"}
              placeholder={`Please assign a category`}
              onChange={this.onCategoryChange}
              parenttype={"project"}
              name={"category"}
              label={"Category"}
              initialValue={this.state.category}
            />
            <InputSelectAdd
              category={"mainsubjectname"}
              placeholder={`Please assign main subject name`}
              onChange={this.onMainSubjectNameChange}
              parenttype={"project"}
              name={"mainsubjectname"}
              label={"Main Subject Name"}
              initialValue={this.state.mainsubjectname}
            />
            <InputSelectAdd
              category={"subsubjectname"}
              placeholder={`Please assign sub subject name`}
              onChange={this.onSubSubjectNameChange}
              parenttype={"project"}
              name={"subsubjectname"}
              label={"Sub Subject Name"}
              initialValue={this.state.subsubjectname}
            />
            {/* <Form.Item
            name="startdate"
            label="Start date"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select test date!",
            //   },
            // ]}
            initialValue={moment()}
          >
            <DatePicker
              placeholder="Please enter a start date"
              // value={scheduledAt}
              format="MM/DD/YYYY"
              className="gx-w-100"
              // onChange={this.onDateChange}
            />
          </Form.Item>
          <Form.Item
            name="enddate"
            label="End date"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select test date!",
            //   },
            // ]}
            // initialValue={moment()}
          >
            <DatePicker
              placeholder="Please enter a end date"
              // value={scheduledAt}
              format="MM/DD/YYYY"
              className="gx-w-100"
              // onChange={this.onDateChange}
            />
          </Form.Item> */}
            <Form.Item
              name="additionalinformation"
              label="Additional Information"
              initialValue={data.additionalinformation}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid additionalinformation",
                },
                // {
                //   required: true,
                //   message: "Please input additionalinformation",
                // },
              ]}
            >
              <Input
                placeholder="Please enter a additionalinformation"
                value={data.additionalinformation}
              />
            </Form.Item>
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                {!!params.id ? "Update" : "Create"}
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div className="gx-loader-view">
            <CircularProgress />
          </div>
        )}
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedProject: state.selfprojects.selectedProject,
  loading: state.selfprojects.loading,
});

const mapDispatchToProps = {
  createProject,
  fetchProject,
  updateProject,
  emptyProject,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfProject);
